module.exports = __webpack_public_path__ + "media/images/ibjjf/logo-ibjjf-vertical-WHITE-2f0eca828e1178f13116b07c579cead2.svg";